const getters = {
  getDefaultCoordinates: state => {
    return state.defaultCoordinates
  },

}

export default getters